import styled from 'styled-components';
import { ThemeColours, transparentThemeColour } from '../../../styles/ThemeColours';
import { FONT_STACK, PRESSABLE } from '../../../styles/constants';
import { propSwitch } from '../../../util/propSwitch';
import { Tick as IconTick } from '../../icons/outlined/Tick';

export interface CheckboxProps {
  checked: boolean;
  disabled?: boolean;
}

export const Checkbox = styled.button<CheckboxProps>`
  ${PRESSABLE}
  background-color: ${props =>
    props.checked
      ? props.disabled
        ? ThemeColours.mono400
        : ThemeColours.primary
      : props.disabled
      ? ThemeColours.mono400
      : ThemeColours.white};
  border: 1px solid ${propSwitch('checked', ThemeColours.primary, ThemeColours.mono300)};
  border-radius: 4px;
  display: inline-block;
  height: 26px;
  min-width: 26px;
  padding: 0;
  width: 26px;

  &:focus {
    background-color: ${props =>
      props.checked
        ? transparentThemeColour('primary', 0.15)
        : transparentThemeColour('black', 0.85)};
  }
`;

export const StyledIconTick = styled(IconTick)`
  color: ${ThemeColours.white};
  height: 24px;
  width: 24px;
`;

export const Label = styled.label`
  ${FONT_STACK}
  color: ${ThemeColours.mono700};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  margin-inline-start: 16px;
`;

export const CheckboxWrapper = styled.div<{ justifyContent?: string }>`
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  justify-content: ${props => props.justifyContent || 'initial'};
  width: 100%;
`;
